import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';

const UNSELECTED_STAR_URL = '/images/stars/Star-Grey-Fill.svg';
const SELECTED_STAR_URL = '/images/stars/Star-Orange-Fill.svg';
const UNDEFINED_STAR_URL = '/images/stars/Star-Outline.svg';
const STAR_HEIGHT_RATIO = 93 / 100; // star height / width ratio

const Container = styled.div`
  white-space: nowrap;
`;

const StarContainer = styled.div`
  display: inline-block;
  position: relative;
  padding: 0 4px;
  cursor: pointer;
  transition: transform 200ms ease;
  ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'width' does not exist on type 'Pick<Deta... Remove this comment to see the full error message
    width,
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'height' does not exist on type 'Pick<Det... Remove this comment to see the full error message
    height,
  }) => css`
    width: ${width}px;
    height: ${height}px;
  `};

  &:hover {
    transform: scale(1.1);
  }
`;

const BaseStar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: no-repeat center center;
  background-size: contain;
  transition: opacity 200ms ease;
  opacity: ${({
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'opacity' does not exist on type 'Pick<De... Remove this comment to see the full error message
    opacity,
  }) => opacity};
`;

const UnselectedStar = styled(BaseStar)`
  background-image: url(${UNSELECTED_STAR_URL});
`;

const UndefinedStar = styled(BaseStar)`
  background-image: url(${UNDEFINED_STAR_URL});
`;

const SelectedStar = styled(BaseStar)`
  background-image: url(${SELECTED_STAR_URL});
`;

type Props = {
  onChange?: (...args: any[]) => any;
  rating?: number;
  className?: string;
  starWidth?: number;
};

type State = any;

export default class StarSelector extends PureComponent<Props, State> {
  state = { hoverIdx: 0 };

  getOpacity = (idx: any, imageUrl: any) => {
    const { rating } = this.props;
    const selection = this.state.hoverIdx || rating;
    switch (imageUrl) {
      default:
      case UNDEFINED_STAR_URL:
        return selection ? 0 : 1;
      case SELECTED_STAR_URL:
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        return idx <= selection ? 1 : 0;
      case UNSELECTED_STAR_URL:
        // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
        return idx > selection ? 1 : 0;
    }
  };

  handleMouseOver = (idx: any) => {
    this.setState({ hoverIdx: idx });
  };

  handleMouseLeave = () => {
    this.setState({ hoverIdx: 0 });
  };

  render() {
    const { onChange, className, starWidth } = this.props;
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const height = starWidth * STAR_HEIGHT_RATIO;

    return (
      <Container className={className} onMouseLeave={this.handleMouseLeave} data-testid="star-sel">
        {[1, 2, 3, 4, 5].map((idx) => (
          // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
          <StarContainer key={idx} onClick={() => onChange(idx)} width={starWidth} height={height}>
            {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'opacity' does not exist on type 'Intrins... Remove this comment to see the full error message */}
            <UnselectedStar opacity={this.getOpacity(idx, UNSELECTED_STAR_URL)} />
            {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'opacity' does not exist on type 'Intrins... Remove this comment to see the full error message */}
            <UndefinedStar opacity={this.getOpacity(idx, UNDEFINED_STAR_URL)} />

            <SelectedStar
              onMouseOver={() => this.handleMouseOver(idx)}
              // @ts-expect-error ts-migrate(2769) FIXME: Property 'opacity' does not exist on type 'Intrins... Remove this comment to see the full error message
              opacity={this.getOpacity(idx, SELECTED_STAR_URL)}
            />
          </StarContainer>
        ))}
      </Container>
    );
  }
}
